<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- main-colum START here -->
      <div id="main-colum">
        <!-- post START here -->
        <router-link :to="{ path: '/admin/testimonials' }" class="big-btn blue">
          Add New Testimonial
        </router-link>
        <br />
        <br />
        <br />
        <br />
        <div
          v-for="(test, index) in testimonials"
          :key="test.id"
          class="colum one_half"
        >
          <blockquote>
            <p>
              <span class="dropcap">{{ index }}</span>
              {{ test.content }}
            </p>
            <cite>{{ test.author }}, &nbsp;<b>{{ test.type }}</b></cite>
          </blockquote>
          <router-link
            :to="{ path: '/admin/testimonial/' + test.id }"
            class="big-btn red"
          >
            Edit
          </router-link>
          <a class="big-btn red" @click.prevent="remove(test)">Delete</a>
        </div>
      </div>
      <!-- main-colum END here -->
    </div>
    <!-- container END here -->
  </div>
  <!-- content END here -->
</template>

<script>
import TestimonialRepository from "../../data/testimonial.repository";
export default {
  data() {
    return {
      testimonials: [],
    };
  },
  created() {
    TestimonialRepository.getTestimonials().then((testimonials) => {
      console.log(testimonials);
      this.testimonials = testimonials;
    });
  },
  methods: {
    remove(testimonial) {
      TestimonialRepository.remove(testimonial).then((result) => {
        this.$root.$refs.toastr.s("Testimonial removed");
        this.$router.push("/admin");
      });
    },
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// ManageTestimonial.vue?32b56e92